"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMap = exports.CSS = void 0;
var tslib_1 = require("tslib");
var mithril_component_1 = require("../../components/mithril.component");
var theme_1 = require("../../components/theme");
var dom_1 = require("../../dom");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var tag_map_overlay_1 = require("./tag.map.overlay");
exports.CSS = {
    container: 'c-Map'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        width: '100%',
        height: '100%'
    },
    _a));
var TagMap = /** @class */ (function (_super) {
    tslib_1.__extends(TagMap, _super);
    function TagMap(state) {
        var _this = _super.call(this) || this;
        _this.state = state;
        return _this;
    }
    TagMap.prototype.onCreate = function (vnode) {
        var _this = this;
        this.map = services_1.Services.Map.attach(vnode.dom);
        this.state.map.setMap(this.map);
        this.map.setMapTypeId('roadmap');
        this.map.set('streetViewControl', true);
        this.overlay = new tag_map_overlay_1.CustomMapOverlay(this.state.map, this.map);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
        this.streetModeListener = this.map.getStreetView().addListener('visible_changed', function () { return _this.trackStreetViewMode(); });
    };
    TagMap.prototype.onRemove = function () {
        this.overlay.setMap(null);
        this.streetModeListener.remove();
    };
    TagMap.prototype.onBeforeRemove = function (vnode) {
        this.overlay.setMap(null);
        this.streetModeListener.remove();
    };
    Object.defineProperty(TagMap.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (!services_1.Services.Map.isReady) {
                return null;
            }
            return (0, mithril_1.m)('div', {
                className: exports.CSS.container,
                onmousemove: dom_1.handleMouseMove,
                onclick: function (e) { return _this.handleMouseClick(e); }
            });
        },
        enumerable: false,
        configurable: true
    });
    TagMap.prototype.handleMouseClick = function (e) {
        var node = (0, dom_1.findDragonNode)(e);
        if (node == null) {
            return;
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        var id = node.getAttribute(dom_1.DRAGON_ID);
        var type = node.getAttribute(dom_1.DRAGON_TYPE);
        this.state.map.zoomToId(type, id);
    };
    TagMap.prototype.trackStreetViewMode = function () {
        var panorama = this.map.getStreetView();
        if (panorama.getVisible()) {
            this.enterTime = Date.now();
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'streetview:enter');
        }
        else {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'streetview:exit', null, Date.now() - this.enterTime);
        }
    };
    return TagMap;
}(mithril_component_1.IMithrilComponent));
exports.TagMap = TagMap;
//# sourceMappingURL=tag.map.js.map